import styles from './Button.module.css'
import { Link } from 'react-router-dom'

interface ButtonProps {
    caption: string
    icon: any
    onClick: (event: any) => void
}

export const Button = (props: ButtonProps): JSX.Element => {
    const {
        caption,
        icon,
        onClick
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={styles.Button}
            onClick={handleButtonClick}
        >
            <span
                className={styles.Button__IconContainer}
            >{icon}</span>

            <span className={styles.Button__CaptionContainer}>
                <span
                    className={styles.Button__Caption}
                >
                    {caption}
                </span>
            </span>
        </button>
    )
}